var map = {
	"./affection-baby-baby-girl-beautiful-377058.jpg": 36,
	"./beautiful-&-simple.jpg": 37,
	"./bosses.jpg": 38,
	"./cestovat-chladny-dno-jednoduchost-2868847.jpg": 39,
	"./elijah.jpg": 40,
	"./fitness-blog-post.jpg": 41,
	"./memories-from.jpg": 42,
	"./nysc1.jpg": 43,
	"./one.jpg": 44,
	"./three.jpg": 45,
	"./two.jpg": 46
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;